import React from 'react';
import './PageLayout.css';
import Footer from '../components/Footer';

function PrivacyPolicy() {
  return (
    <div className="page-layout">
      <header className="page-header">
        <a href="/" className="page-back-link">← Back to Don't Wordle</a>
      </header>
      <main className="page-content">
        <h1>Privacy Policy</h1>
        <div className="page-body">
          <p><strong>Last updated:</strong> March 6, 2026</p>

          <h2>Introduction</h2>
          <p>Welcome to Don't Wordle. This Privacy Policy explains how information may be collected, used, and disclosed when you visit or use this website.</p>
          <p>The site is designed to provide a simple online word game experience. We aim to collect as little information as possible.</p>

          <h2>Information We Collect</h2>
          <p>This website does not require users to create accounts or submit personal information.</p>
          <p>However, limited information may be collected automatically through analytics tools to help understand how visitors use the site.</p>

          <h3>Analytics Information</h3>
          <p>This website uses Google Analytics to collect basic usage statistics, such as:</p>
          <ul>
            <li>Pages visited</li>
            <li>Time spent on the site</li>
            <li>General geographic region (such as country or state)</li>
            <li>Device type and browser information</li>
            <li>Approximate traffic sources</li>
          </ul>
          <p>This information is collected in aggregate form and is used solely to understand how the website is used and how it can be improved.</p>
          <p>Google Analytics may use cookies or similar technologies to collect this information.</p>

          <h2>Advertising</h2>
          <p>This website may display advertisements provided by third-party advertising networks such as Google AdSense.</p>
          <p>Third-party vendors, including Google, may use cookies to serve ads based on a user's prior visits to this website or other websites.</p>
          <p>Users may opt out of personalized advertising by visiting Google's Ads Settings.</p>

          <h2>Cookies</h2>
          <p>Cookies are small data files stored on your device that help websites function and understand usage patterns.</p>
          <p>This site may use cookies for:</p>
          <ul>
            <li>Website functionality</li>
            <li>Analytics through Google Analytics</li>
            <li>Advertising services</li>
          </ul>
          <p>You can control or disable cookies through your browser settings.</p>

          <h2>Third-Party Services</h2>
          <p>This website may use third-party services that collect, monitor, and analyze usage data. These services operate under their own privacy policies.</p>
          <p>Examples include:</p>
          <ul>
            <li>Google Analytics</li>
            <li>Advertising providers such as Google AdSense</li>
          </ul>

          <h2>Data Security</h2>
          <p>Because this site does not collect personal user accounts or personal data, we do not store sensitive user information. Reasonable technical measures are used to maintain the security of the website.</p>

          <h2>Children's Privacy</h2>
          <p>This website is not directed at children under the age of 13 and does not knowingly collect personal information from children.</p>

          <h2>Changes to This Privacy Policy</h2>
          <p>This Privacy Policy may be updated from time to time. Any updates will be posted on this page with a revised "Last updated" date.</p>

          <h2>Contact</h2>
          <p>If you have questions about this Privacy Policy, you can contact the site operator at:</p>
          <p>dontwordle@gmail.com</p>
        </div>
      </main>
      <div className="page-footer-slot">
        <Footer />
      </div>
    </div>
  );
}

export default PrivacyPolicy;
